// extracted by mini-css-extract-plugin
export var aggregationCell = "_2j-n";
export var aggregationRow = "_2j-m";
export var borderlessSpinnerContainer = "_2j-3";
export var cardLayout = "_2j-6";
export var cardLayoutNoFooter = "_2j-9";
export var cardLayoutPageControl = "_2j-8";
export var closeIcon = "_2j-f";
export var columnHeaderSurface = "_2j-b";
export var columnHeaderSurfaceDragOverlay = "_2j-v";
export var columnHeaderSurfaceResizing = "_2j-s";
export var contextMenuAnchor = "_2j-1";
export var draggableColumnHeader = "_2j-t";
export var draggableColumnHeaderOverlay = "_2j-u";
export var expandIcon = "_2j-g";
export var expanded = "_2j-h";
export var filterDropdown = "_2j-i";
export var filterDropdownDivider = "_2j-d";
export var filterDropdownHeader = "_2j-l";
export var filterDropdownItem = "_2j-k";
export var filterDropdownModal = "_2j-j _2j-i";
export var filterItem = "_2j-c";
export var normalCellWithAdjustableBorder = "_2j-e";
export var pinButtonContainer = "_2j-o";
export var pinIcon = "_2j-p";
export var pinIconActive = "_2j-q";
export var spinner = "_2j-0";
export var spinnerContainer = "_2j-2";
export var tableContainer = "_2j-4";
export var tableContentDraggingColumns = "_2j-a";
export var tableContentInner = "_2j-7";
export var tableContentWrapper = "_2j-5";
export var viewButtonContainer = "_2j-r";